var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ValueEditor } from '@easydata/core';
/**
 * Represents a value editor.
 */
var EqValueEditor = /** @class */ (function (_super) {
    __extends(EqValueEditor, _super);
    /** The default constructor. */
    function EqValueEditor() {
        return _super.call(this) || this;
    }
    /**
     * Loads value editor from its JSON representation object.
     * @param data The JSON representation object.
     */
    EqValueEditor.prototype.loadFromData = function (data) {
        _super.prototype.loadFromData.call(this, data);
        if (data) {
            if (data.sql) {
                this.statement = data.sql;
            }
            if (data.extraParams) {
                this.extraParams = data.extraParams;
            }
        }
    };
    return EqValueEditor;
}(ValueEditor));
export { EqValueEditor };
//# sourceMappingURL=value_editor.js.map